angular.module('callX').service('CampaignsService', ['$http', '$rootScope', 'UserService',
  function ($http){

    var getCampaignsList = function(callbacks){
      $http.get("/japi/campaign/campaign?status=publisher")
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getApplyCampaignsList = function(callbacks){
          $http.get("/japi/campaign/campaign?status=with-offer")
              .success(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              });
    };

    var getCampaignsData = function(campaignId, callbacks){
          $http.get("/japi/campaign/campaign/"+campaignId)
              .success(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              });
    };

      var testIVR = function(testIVRDetails, callbacks){
          $http.post("/japi/ivr/play",testIVRDetails)
              .success(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              });
      };

      var addPromoNumberWithDescription = function(campaignId, data, callbacks){
          $http.post("/japi/campaign/" + campaignId + "/promo-number", data)
              .success(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              });
      };

      var savePromoNumberDescription = function(campaignId, data, callbacks){
          $http.put("/japi/campaign/promo-number/"+campaignId, data)
              .success(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              });
      };

      var removePromoNumber = function(campaignId, callbacks){
          $http.delete("/japi/campaign/promo-number/"+campaignId)
              .success(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              });
      };

      var requestAccessToLeads = function(campaignId, publisherId, callbacks){
          $http.put("/japi/publisher/leadapply/"+campaignId+"?id="+publisherId)
              .success(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              });
      };

      var applyToThisCampaign = function(campaignId, applicationDetails, callbacks){
          $http.post("/japi/campaign/" + campaignId + "/apply",applicationDetails)
              .success(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              });
      };

      var getGraphData = function (id, activeDate, dataType, dateRangeValue, plotBy, callbacks) {
          var _data = {
              data_type: dataType,
              ref_from: dateRangeValue[0],
              ref_to: dateRangeValue[1],
              plotby: plotBy
          };
          $http.get("/japi/campaign/summary/"+id+"?ref="+activeDate, { params: _data })
              .success(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              });
      };

      var getPromoTableData = function (id, publisherId, activeDate, dateRangeValue, callbacks) {
          var _data = {
              ref_from: dateRangeValue[0],
              ref_to: dateRangeValue[1]
          };
          $http.get("/japi/campaign/"+id+"/promo-number?status=publisher&publisher_id="+publisherId+"&ref="+activeDate, { params: _data })
              .success(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              });
      };

    var fetchLeadsAccessStatus = function (campaignId, publisherId, callbacks) {
        $http.get("japi/publisher/leadpage/secure/"+campaignId+"?id="+publisherId)
            .success(function (data, status) {
                if(callbacks !== undefined) { callbacks.success(data, status); }
            })
            .error(function (data, status) {
                if(callbacks !== undefined) { callbacks.success(data, status); }
            });
    };

    var fetchLeadsAccessStatusUnsecured = function (campaignId, publisherId, callbacks) {
        $http.get("japi/publisher/leadpage/unsecure/"+campaignId+"?id="+publisherId)
            .success(function (data, status) {
                if(callbacks !== undefined) { callbacks.success(data, status); }
            })
            .error(function (data, status) {
                if(callbacks !== undefined) { callbacks.success(data, status); }
            });
    };

    return {
      getCampaignsList: function (callbacks) {
        getCampaignsList(callbacks);
      },
      getApplyCampaignsList: function (callbacks) {
        getApplyCampaignsList(callbacks);
      },
      getCampaignsData: function (campaignId, callbacks) {
        getCampaignsData(campaignId, callbacks);
      },
      getPublisherCampaignData: function(id, pId) {
          return $http.get("/japi/campaign/campaign/"+id+"?id="+pId, {
              transformResponse: function(json, headerGetter) {
                  return eval("(" + json + ")");
              }
          });
      },
      getGraphData: function (id, activeDate, dataType, dateRangeValue, plotBy, callbacks) {
          getGraphData(id, activeDate, dataType, dateRangeValue, plotBy, callbacks);
      },
      getPromoTableData: function (id, publisherId, activeDate, dateRangeValue, callbacks) {
          getPromoTableData(id, publisherId, activeDate, dateRangeValue, callbacks);
      },
      checkPublisherCampaignApplied: function(campaignId, publisherId) {
          return $http.get("/japi/campaign/publisher/"+campaignId+"?publisher_id="+publisherId);
      },
      testIVR: function (testIVRDetails, callbacks) {
          testIVR(testIVRDetails, callbacks);
      },
      addPromoNumberWithDescription: function (campaignId, data, callbacks) {
          addPromoNumberWithDescription(campaignId, data, callbacks);
      },
      savePromoNumberDescription: function (promoId, data, callbacks) {
          savePromoNumberDescription(promoId, data, callbacks);
      },
        removePromoNumber: function (promoId, callbacks) {
          removePromoNumber(promoId, callbacks);
      },
      requestAccessToLeads: function (campaignId, publisherId, callbacks) {
          requestAccessToLeads(campaignId, publisherId, callbacks);
      },
      fetchLeadsAccessStatus: function (campaignId, publisherId, callbacks) {
          fetchLeadsAccessStatus(campaignId, publisherId, callbacks);
      },
      fetchLeadsAccessStatusUnsecured: function (campaignId, publisherId, callbacks) {
          fetchLeadsAccessStatusUnsecured(campaignId, publisherId, callbacks);
      },
      applyToThisCampaign: function (campaignId, applicationDetails, callbacks) {
          applyToThisCampaign(campaignId, applicationDetails, callbacks);
      },
      checkEmail: function(email) {
        return $http.get("/japi/user-email/"+email);
      },
      getCountryCodes : function (){
        var countryCodes = [
            {
                "country":"United States",
                "code":"1"
            }
        ];
        return countryCodes;
      }
    };
  }]);